import { type EWithdrawalStatus } from '@mahawi/eshop-common/src/types';
import React from 'react';

import StatusTag from '../status-tag';
import { WITHDRAWAL_STATUS_LABEL } from './labels';

function WithdrawalStatusTag({
  status,
}: {
  status: EWithdrawalStatus;
}): React.ReactElement {
  return <StatusTag status={status} label={WITHDRAWAL_STATUS_LABEL[status]} />;
}

export default WithdrawalStatusTag;
